import React from 'react';

import AlertManager from 'src/components/alert';
import { lang, upperFirstCharAll, userFullName } from 'src/helpers';

import List from 'src/storage/treatmentsList';
import { Continue } from './Continue';
import constants from 'src/constants';
import LANG_CONST from 'src/helpers/lang/const';

class AppointmentModel extends List {
  id = 'appointment';
  defaultState = () => ({
    sortBy: {
      sortKey: 'startDate',
      desc: true
    },
    current: 'recent',
    total: 0,
    pageIndex: 0
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'appointment/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'appointment_list'
    },
    list: {
      url: 'appointment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'appointment_list'
    },
    search: {
      url: 'appointment/search',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'appointment_list'
    },
    updateStatus: {
      url: 'appointment/update/status',
      validation: {
        id: 'string',
        value: 'string'
      },
      cancellable: true
    },
    getAvailableSlots: {
      url: 'schedule/listAvailable',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    }
  };
  _events = {
    // appointment_list: 'onAppointmentList',
    'foxsocket:message:msg': 'onMessage',
    'foxsocket:message:msg_update': 'onMessageUpdateWS',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  filterItem = (data) => data.msgType === 'appointment';

  listParams() {
    let { pageIndex, startDate } = this.state;
    if (!startDate) startDate = 0;
    else startDate = parseInt(startDate.startOf('day').valueOf());
    let req = {
      partnerId: 0,
      sortBy: this.state.sortBy,
      skip: pageIndex * this.listLimit,
      limit: this.listLimit,
      statusGroup: [],
      startDate,
      doctorIds: this.state.user?.doctorIds || [],
      hospitalIds: this.state.hospitalId && [this.state.hospitalId]
    };

    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  updateStatus = (item, status, cb) => {
    const req = {
      id: item.id,
      value: status
    };
    let prevStatus = item.data.status || 'upcoming';
    item.data.status = status;
    this.setListStateSilent({ updated: Date.now() });
    this.api('updateStatus', req, (err, res, success) => {
      cb && cb(err, res, success);
      if (!success) {
        item.data.status = prevStatus;
        this.setListStateSilent({ updated: Date.now() });
      }
    });
  };

  showCancel = (item, cb) => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      title: LANG_CONST.notice.cancel_appointment,
      maxWidth: 520,
      cancelButton: {
        label: LANG_CONST.buttons.cancel,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.cancel_appointment,
        action: (actions) => {
          actions.setLoading(true);
          this.updateStatus(item, 'cancelled', (err, res) => {
            try {
              if (!err) {
                cb && cb(res);
                actions.hide();
                AlertManager.popup(AlertManager.TYPES.WARN, {
                  maxWidth: 400,
                  title: LANG_CONST.notice.cancelled_appointment,
                  close: false,
                  actionButton: {
                    label: LANG_CONST.buttons.ok,
                    action: (actions) => actions.hide()
                  }
                });
              }
            } catch (err) {
              console.log('ConfirmCancel hide err', err);
            }
            actions.setLoading(false);
          });
        }
      }
    });
  };

  showContinue = (item, router) => {
    AlertManager.popup(AlertManager.TYPES.BASE, {
      title: 'Continue with',
      maxWidth: 300,
      body: (props) => <Continue {...props} item={item} router={router} />,
      cancelButton: {
        label: 'Back',
        action: (actions) => actions.hide()
      }
    });
  };

  checkDisabledDoctor = (doctor) => {
    if (doctor.status === constants.general.userStatus.disabled) {
      if (doctor.id === model.state.user.id) model.emit('checkDisabledAccount', model.state.user);
      else
        AlertManager.popup(AlertManager.TYPES.INFO, {
          maxWidth: 450,
          close: false,
          title:
            doctor.role.includes('_') && doctor.clinicName
              ? lang.t(LANG_CONST.notice.disabled_clinic_doctor, {
                  clinic: upperFirstCharAll(doctor.clinicName),
                  doctor: upperFirstCharAll(userFullName(doctor))
                })
              : lang.t(LANG_CONST.notice.disabled_doctor, {
                  doctor: upperFirstCharAll(userFullName(doctor))
                }),

          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (props) => props.hide()
          }
        });
      return true;
    }

    return false;
  };
}

const model = new AppointmentModel();
export default model;
